export default {
  NECD: 'New Estimated Completion',
  TRAC: 'Repair On Track',
  COMP: 'Repair Completed',
  PICK: 'Customer pick up, vehicle delivered to customer or assesment'
}
